import React from 'react';
import { useLoginModal } from '../../components/LoginModalContext';
import Button from '../../components/Button/Button';
import loginRequiredImage from '../../images/loginRequired.png';
import './LoginRequired.css';

/**
 * LoginRequired komponenten vises når en bruger forsøger at tilgå Champions League spillet uden at være logget ind.
 * 
 * @component
 * @description
 * Viser en besked om at brugeren skal være logget ind for at spille Champions League,
 * sammen med en knap til at åbne login modal.
 * 
 * @returns {JSX.Element} LoginRequired komponenten
 */
const LoginRequired = () => {
  const { openLogin } = useLoginModal();

  return (
    <div className="login-required-background"> 
    <div className="login-required-container">
      <div className="login-required-content">
        <div className="login-required-icon">
          <img 
            src={loginRequiredImage} 
            alt="Login påkrævet" 
          />
        </div>
      
        <p className="login-required-message">
          Du skal være logget ind for at kunne tilgå denne side.
        </p>
        
        <Button 
          title="Log Ind"
          onClick={openLogin}
          variant="contained"
          color="primary"
          style={{ width: '100%', marginTop: '8px' }}
          disabled={false}
        >
        </Button>
      
      </div>
    </div>
    </div>
  );
};

export default LoginRequired;
